import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarUser from './NavbarUser';
import SideNav from './SideNav';
import Navbar from '../web-pages/Navbar';
function Header(props) {
 const [mobileOpen, setMobileOpen] = useState(false);


    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    return (
        <div className='navigation'>
            <NavbarUser handleDrawerToggle={handleDrawerToggle} />
            <Navbar />
            <SideNav mobileOpen={mobileOpen} handleDrawerToggle={() => handleDrawerToggle()} />

        </div>



    );
}

export default Header;
